import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ChatMessage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { GetLandingPageChatAgentMessagesStaticFilter } from '../../endpoints/landing-pages';

export const getLandingPageChatAgentMessages = async (
  params: GetCollectionQueryParams<ChatMessage, GetLandingPageChatAgentMessagesStaticFilter>,
): Promise<ApiCollectionResponse<ChatMessage>> => {
  return await tinctApi.landingPages.getLandingPageChatAgentMessages(params);
};

export const useGetLandingPageChatAgentMessages = (
  params: GetCollectionQueryParams<ChatMessage, GetLandingPageChatAgentMessagesStaticFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ChatMessage>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: [
      'landing-pages',
      params.staticParams?.landingPageId,
      'chat-agent-messages',
      params,
    ],
    queryFn: () => getLandingPageChatAgentMessages(params),
    ...options,
  });
